export default __webpack_public_path__ + "static/media/parentImg.31afaf2b.png";